import { render } from "./RegisterPage.vue?vue&type=template&id=b92dd50e"
import script from "./RegisterPage.vue?vue&type=script&lang=ts"
export * from "./RegisterPage.vue?vue&type=script&lang=ts"
script.render = render

export default script